export default __webpack_public_path__ + "static/media/checked_calendar.0a630767.svg";